import React from 'react';

function PageFooter({ title, text, primaryLabel, primaryHref, secondaryLabel, secondaryHref, secondaryExternal = false }) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="App-footer">
      <div className="footer-content">
        <div className="footer-cta">
          <h3>{title}</h3>
          <p>{text}</p>
          <div className="button-group">
            <a href={primaryHref} className="button primary">{primaryLabel}</a>
            <a
              href={secondaryHref}
              className="button secondary"
              target={secondaryExternal ? '_blank' : undefined}
              rel={secondaryExternal ? 'noreferrer' : undefined}
            >
              {secondaryLabel}
            </a>
          </div>
        </div>
        <div className="footer-meta">
          <p>&copy; {currentYear} Databuilder Limited.</p>
          <p>Registered in England &amp; Wales.</p>
        </div>
      </div>
    </footer>
  );
}

export default PageFooter;